export const parseNumber = (value?: string): number | undefined => {
  if (!value) return undefined;

  const num = parseInt(value);
  if (Number.isNaN(num)) return undefined;

  return num;
};
